export enum AccountStateEnum {
  Active = "Active",
  Suspended = "Suspended",
  Pending = "Pending",
  Review = 'Review',
  Approved = 'Approved',
  Denied = 'Denied'
}
